var store = require('../../../../../../../app_adyen_SFRA/cartridge/config/store');
var _require1 = require('./helpers'),
    assignPaymentMethodValue = _require1.assignPaymentMethodValue,
    showValidation = _require1.showValidation;
var _require3 = require('adyen/adyen/checkout/checkoutConfiguration'),
  actionHandler = _require3.actionHandler;
var scrollAnimate = require('base_global/components/scrollAnimate');

var summaryHelpers = require('base_global/checkout/summary');
var rewardHelpers = require('antavo_custom/handleReward');
var tealiumEnable = require('int_tealium_sfra/tealiumEnable');

var $giftCardInfo = $('.gift-card-info .max-limit-error');
var $maxLimitMsg = $('.gift-card-info .max-limit-error .max-limit-msg');

function trackServersideError(balanceResponse) {
    if (balanceResponse && (balanceResponse.maxCardApplied || (balanceResponse.args && balanceResponse.args.errorCode))) {
        var errorCode = balanceResponse.args ? balanceResponse.args.errorCode : balanceResponse.errorCode;
        tealiumEnable.getAnalyticsData('serverError', errorCode);
    }
}

function giftCardCheckBalance(data) {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: window.giftcardRedeemURL,
            type: 'post',
            data: {
                data: JSON.stringify(data),
                paymentMethod: 'valuelink'
            },
            success: function (balanceResponse) {
                $('#valuelink-container > .adyen-checkout-contextual-text--error').remove();
                if (balanceResponse && balanceResponse.args && balanceResponse.args.adyenErrorMessage) {
                    $('#valuelink-container').prepend('<div class="adyen-checkout-contextual-text--error">' + balanceResponse.args.adyenErrorMessage + '</div>');
                }
                resolve(balanceResponse);
            },
            error: function (err) {
                $('#valuelink-container > .adyen-checkout-contextual-text--error').remove();
                if (err.responseJSON?.action === "Ajax-Response" && err.responseJSON?.success === false) {
                    let akamaiErrorMessage = $('.checkoutPage-giftcard-akamai-error').data('checkout-giftcard-akamai-error');
                    $('.checkout-error-akamai-alert').empty().append(`<div class="checkout-error-akamai-message"><span class="icon-alert"></span><span class="err-message">${akamaiErrorMessage} ${err.responseJSON["ckdr:"] ? err.responseJSON["ckdr:"] : err.responseJSON["thdr:"]}</span></div>`);
                }
                if (err.responseJSON && err.responseJSON.error && err.responseJSON.error.errorText) {
                    $('#valuelink-container').prepend('<div class="adyen-checkout-contextual-text--error">' + err.responseJSON.error.errorText + '</div>');
                }
                reject(err);
            }
        });
    });
}

function showGiftCardAppleInfo () {
    if($('body.apple-pay-enabled').length > 0) {
        $('.gift-card-apple-info').removeClass('d-none');
    }
}

function giftCardFieldError() {
    setTimeout(() => {
        var errorElement;
        var errorMessage;
        if (document.querySelector('#valuelink-container .adyen-checkout__field--number').classList.contains('adyen-checkout__field--error')) {
            $('#valuelink-container > .adyen-checkout-contextual-text--error').remove();
                errorElement = document.querySelector('#valuelink-container .adyen-checkout__field--number .adyen-checkout-contextual-text--error');
                errorMessage = document.getElementById('giftcardErrorMsg').value;

            // Safely set the error message as plain text
            errorElement.textContent = errorMessage;
        } else {
            document.querySelector('#valuelink-container .adyen-checkout__field--number .adyen-checkout-contextual-text--error').textContent = '';
        }

        if (document.querySelector('#valuelink-container .adyen-checkout__field--pin').classList.contains('adyen-checkout__field--error')) {
            $('#valuelink-container > .adyen-checkout-contextual-text--error').remove();
            errorElement = document.querySelector('#valuelink-container .adyen-checkout__field--pin .adyen-checkout-contextual-text--error');
            errorMessage = document.getElementById('pinErrorMsg').value;
            // Safely set the error message as plain text
            errorElement.textContent = errorMessage;
        } else {
            document.querySelector('#valuelink-container .adyen-checkout__field--pin .adyen-checkout-contextual-text--error').textContent = '';
        }
    }, 0);
}

function giftCardRemove(cardNumber, $this) {
    var data = {
        giftCardCode: cardNumber
    }
    $.ajax({
        url: window.giftcardRemoveURL,
        type: 'post',
        data: data,
        success: function success(balanceResponse) {
            $this.closest('.applied-card').remove();
            summaryHelpers.updateTotals(balanceResponse.order.totals);
            rewardHelpers.rewardsResponse(balanceResponse);

            let parsedTotal = parseFloat(balanceResponse.order.totals.grandTotal.split('$').join(''));

            if (parsedTotal > 0) {
                var adyenCheckout = require('../checkout');
                adyenCheckout.init();
            }

            if ($('.applied-card').length) {
                showGiftCardAppleInfo();
                setTimeout(() => {
                    $('.applePay-list input').attr('disabled', 'disabled');
                }, 1000);
            } else {
                $('.applied-card-container').removeClass('gift-card-border');
                $('.gift-card-apple-info').addClass('d-none');
            }

            $('.gift-card-form-fields').removeClass('d-none');
            $('.gift-card-info .order-total-msg').addClass('d-none');
            $('.gift-card-form .adyen-checkout-contextual-text--error').remove();
            $giftCardInfo.addClass('d-none');
        }
    });
}

function giftcardConfiguration() {
    if (window.adyenGiftCard) {
        window.adyenGiftCard.unmount();
    }
    //var giftCardAmount = store.partialPaymentsOrderObj && store.partialPaymentsOrderObj.remainingAmount ? store.partialPaymentsOrderObj.remainingAmount : store.checkout.options.amount;
    var giftCard = window.AdyenWeb.createComponent('giftcard', store.checkout, ({}, store.paymentMethodsConfiguration['giftcard']), {}, {
        brand: 'valuelink',
        pinRequired: true,
        showPayButton: true,
        styles: {
            placeholder: {
                color: '#696969'
            }
        },
        onChange: function(state) {
            giftCardFieldError();
        },
        onFocus: function(state) {
            giftCardFieldError();
        },
        onBlur: function(state) {
            giftCardFieldError();
        },
        onBalanceCheck: async function (resolve, reject, data) {
            $('#valuelink-container > .adyen-checkout__error-text').remove();
            try {
                const balanceResponse = await giftCardCheckBalance(data);
                if (balanceResponse && balanceResponse.giftCardBalance && balanceResponse.giftCardBalance.resultCode === 'Success') {
                    tealiumEnable.getAnalyticsData('giftCardSuccess');
                }
                trackServersideError(balanceResponse);
                
                if (balanceResponse) {
                    if (balanceResponse.maxCardApplied) {
                        $('.gift-card-form-fields').addClass('d-none');
                        $maxLimitMsg.html(balanceResponse.message);
                        $giftCardInfo.removeClass('d-none');
                    } else {
                        var giftCardCount = balanceResponse.order.totals.giftCardTotals.giftCardCount.count;
                        let appliedCardAmount = balanceResponse.order.totals.giftCardTotals.appliedGiftCard[giftCardCount-1];
                        let $appliedCard = $('.applied-card-placeholder').clone();
                        let encryptedCardNumber = data.paymentMethod.encryptedCardNumber;
                        $appliedCard.find('.applied-card__amount').text(appliedCardAmount);
                        $appliedCard.find('a.remove').data('cardnumber', encryptedCardNumber);
                        $appliedCard.removeClass('applied-card-placeholder d-none');
                        $appliedCard.addClass('applied-card');
                        $('.applied-card-container').append($appliedCard);
                        if ($appliedCard.length === 1) {
                            $('.applied-card-container').addClass('gift-card-border');
                        }
    
    
                        summaryHelpers.updateTotals(balanceResponse.order.totals);
                        rewardHelpers.rewardsResponse(balanceResponse);
    
                        let parsedTotal = parseFloat(balanceResponse.order.totals.grandTotal.split('$').join(''));
                        if (parsedTotal <= 0) {
                            $('#rb_giftcard').trigger('click');
                            $('#paymentMethodsList input:radio').attr('disabled', 'disabled');
                            $('.gift-card-apple-info').addClass('d-none');
                            $('.gift-card-form-fields').addClass('d-none');
                            $('.gift-card-info .order-total-msg').removeClass('d-none');
                        } else {
                            var adyenCheckout = require('../checkout');
                            adyenCheckout.init();
                            showGiftCardAppleInfo();
                        }
                    }
                }
                giftcardConfiguration();
                resolve(balanceResponse.giftCardBalance);
    
                setTimeout(() => {
                    $('.applePay-list input').attr('disabled', 'disabled');
                }, 1000);
            } catch (err) {
                if(err.responseJSON?.action === "Ajax-Response" && err.responseJSON?.success === false) {
                    let akamaiErrorMessage = $('.checkoutPage-giftcard-akamai-error').data('checkout-giftcard-akamai-error');
                    $('.checkout-error-akamai-alert').empty().append(`<div class="checkout-error-akamai-message"><span class="icon-alert"></span><span class="err-message">${akamaiErrorMessage} ${err.responseJSON["ckdr:"] ? err.responseJSON["ckdr:"] : err.responseJSON["thdr:"]}</span></div>`);
                }
                    reject(err);
            }
        },
        onError: (error) => {
            setTimeout(() => {
                if (error.error === "originKeyError") {
                    // Remove gift card fields on load error
                    let errorMsg = $('#paymentMethodUnavailableMsg').val();
                    $('.gift-card-form .gift-card-form-fields').remove();
                    $('.gift-card-form').append(`<div class="payment-unavailable-msg"></div>`);
                    $('.gift-card-form').find('.payment-unavailable-msg').text(errorMsg)
                }
                var errorElement;
                var errorMessage;
                if (error.error === "error.va.gen.01") {
                    $('#valuelink-container > .adyen-checkout__error-text').remove();
                    if (error.fieldType === "encryptedCardNumber" && error.error !== "") {
                        errorElement = document.querySelector('.adyen-checkout__field--number .adyen-checkout__error-text');
                        errorMessage = document.getElementById('giftcardErrorMsg').value;

                        // Safely set the error message as plain text
                        errorElement.textContent = errorMessage;
                    }
                    if (error.fieldType === "encryptedSecurityCode" && error.error !== "") {
                        errorElement = document.querySelector('.adyen-checkout__field--pin .adyen-checkout__error-text');
                        errorMessage = document.getElementById('pinErrorMsg').value;
                        // Safely set the error message as plain text
                        errorElement.textContent = errorMessage;
                    }
                }
            }, 0);
        }
    }).mount('#valuelink-container');

    window.adyenGiftCard = giftCard;
}

function renderGiftCard() {
    giftcardConfiguration();
    $(document).on('click', '.applied-card-container .remove', function () {
        giftCardRemove($(this).data('cardnumber') , $(this));
        // We need to delete handlers to avoid handlers duplication
        $(document).off('click','.applied-card-container .remove');
    });

    let grandTotal = $('.d-summary-xs .grand-total-sum.estimated_total').text();
    let parsedTotal = parseFloat(grandTotal.split('$').join(''));

    if (parsedTotal <= 0 && $('.applied-card').length) {
        $('#rb_giftcard').trigger('click');
        $('#paymentMethodsList input:radio').attr('disabled', 'disabled');
        $('.gift-card-form-fields').addClass('d-none');
        $('.gift-card-info .order-total-msg').removeClass('d-none');
        $giftCardInfo.addClass('d-none');
    } else {
        $('.gift-card-form-fields').removeClass('d-none');
        $('.gift-card-info .order-total-msg').addClass('d-none');
        $giftCardInfo.addClass('d-none');
    }

    if ($('.applied-card').length) {
        $('.applePay-list input').attr('disabled', 'disabled');
    }

    if ($('.applied-card-container .applied-card').length >= 1) {
        $('.applied-card-container').addClass('gift-card-border');
    }
}

function updateAddressDetails() {
    var firstPaymentMethod = document.querySelector('input[type=radio][name=brandCode]');
    var billingInfo = $('.billing-info-payment-binding').contents().clone();
    var $selectedCountry = $('.billing-info-payment-binding #billingCountry');
    var $selectedState = $('.billing-info-payment-binding select#billingState');
    if (firstPaymentMethod.id === 'rb_scheme') {
        $('.payment-billing-cc').empty().append(billingInfo);
        if ($selectedCountry.attr('data-countrycode')) {
            $('.payment-billing-cc #billingCountry').val($selectedCountry.attr('data-countrycode'));
        }
        if ($selectedState.attr('data-statecode')) {
            $('.payment-billing-cc select#billingState').val($selectedState.attr('data-statecode'));
        }

    } else {
        $('.payment-billing-saved-cc').empty().append(billingInfo);
        if ($selectedCountry.attr('data-countrycode')) {
            $('.payment-billing-saved-cc #billingCountry').val($selectedCountry.attr('data-countrycode'));
        }
        if ($selectedState.attr('data-statecode')) {
            $('.payment-billing-saved-cc select#billingState').val($selectedState.attr('data-statecode'));
        }
    }
    firstPaymentMethod.checked = true;
}

function handleAddressUpdateOnInputChange (event) {
    $('.payment-billing-cc').empty();
    $('.payment-billing-saved-cc').empty();
    var billingInfo = $('.billing-info-payment-binding').contents().clone();
    var $selectedCountry = $('.billing-info-payment-binding #billingCountry');
    var $selectedState = $('.billing-info-payment-binding select#billingState');
    $('.gift-card-form, .gift-card-form-fields').removeClass('d-none');
    $('.gift-card-info .apple-pay-msg').addClass('d-none');
    $('#billingSameAsShippingID')[0].checked = true;
    $('#billingSameAsShippingID').trigger('change');
    if (event.target.value === 'scheme') {
        $('.payment-billing-cc').empty().append(billingInfo);
        if ($selectedCountry.attr('data-countrycode')) {
            $('.payment-billing-cc #billingCountry').val($selectedCountry.attr('data-countrycode'));
        }
        if ($selectedState.attr('data-statecode')) {
            $('.payment-billing-cc select#billingState').val($selectedState.attr('data-statecode'));
        }
        var creditPayHtml = $('.payment-credit-text').html();
        $(".payment-credit-text").addClass('d-none');
        $(".payment-billing-cc").append(creditPayHtml);
    } else if (event.target.value.startsWith('storedCard')) {
        $('.payment-billing-saved-cc').empty().append(billingInfo);
        if ($selectedCountry.attr('data-countrycode')) {
            $('.payment-billing-cc #billingCountry').val($selectedCountry.attr('data-countrycode'));
        }
        if ($selectedState.attr('data-statecode')) {
            $('.payment-billing-cc select#billingState').val($selectedState.attr('data-statecode'));
        }
    } else if (event.target.value === 'applepay') {
        let $applePayMsg = encodeURIComponent($('#applePayMsg').val());
        $('#component_applepay').empty().append(`<div class="applyPayMsg">` + decodeURIComponent($applePayMsg)).append('<isapplepay class="dw-apple-pay-button dw-apple-pay-logo-white dw-apple-pay-border btn btn-block analytic-applepay-button"></isapplepay>');
        $('.gift-card-form-fields').addClass('d-none');
        $('.gift-card-info .apple-pay-msg').removeClass('d-none');
        $('body').trigger('render:giftCard');
    }
}

function creditDesText() {
    if($('#rb_scheme').is(':checked')) {
        var creditPayHtml = $('.payment-credit-text').html();
        $(".payment-credit-text").addClass('d-none');
        $(".payment-billing-cc").append(creditPayHtml);
    }
}
function credictCardList() {
    var paymentmethodlabel = $('#lb_scheme.payment-method-label');
    var cclist = $('.creditcardlist-content').html();
    paymentmethodlabel.find('.payment-method-different-cards').addClass('d-none');
    paymentmethodlabel.find('.creditcard-lists').remove();
    paymentmethodlabel.append(cclist);
}
function applePayContent() {
    $('#rb_applepay').one('click', function(){
        var htmlContent = $('.payment-applepay-text').html();
        $("#component_applepay").prepend(htmlContent);
    });
    // GCT-21671 + GDC-8652 - Update SFCC Apple Pay cookie to trigger contact address refresh (onRequest) when selected
    $('#rb_applepay').on('input', () => {
        cookieSet.set('dwapupreq', new Date().getTime());
    });
}

function klarnaDesText() {
    $('#rb_klarna_account').one('click', function(){
        var klarnaHtml = $('.klarna-content').html();
        $(".klarna-available-msg").append(klarnaHtml);
    });
}
function paypalDesText() {
    $('#rb_paypal').one('click', function(){
        var paypalHtml = $('.payment-paypal-text').html();
        $("#component_paypal").prepend(paypalHtml);
    });
}

function updatePlaceOrderButton() {
    // GCT-15300 | Paypal Express changes | GCT-17209 Edit payment/ship/cart scenerio with paypal express order
    var  genericPlaceOrderUrl = $('#genericPlaceOrderUrl');
    if( genericPlaceOrderUrl && genericPlaceOrderUrl.data('url')){
        var submitOrder = $('#submit-order');
        submitOrder.attr('data-action', genericPlaceOrderUrl.data('url'));
        submitOrder.attr('name', 'submit');
        $('#showConfirmationForm').remove();
    }
}

function generateLiContent(paymentMethodID, paymentMethod , label, isStored) {
    var liContents = '';
    var isKlarnaEnable = $('.js-grand-total').data('isklarnadisable') ? 'disabled' : '';
    var showKlarnaErrorMessage = $('.js-grand-total').data('isklarnadisable') ? $('.js-grand-total').data('klarna-errormessage') : '';
    var klarnaAvailableMsg = $('.js-grand-total').data('klarna-message');
    var paypalDesText = $('.payment-paypal-text').html();
    var paymentUnavailable = $('#paymentMethodUnavailableMsg').val();
    var afterpayEnabledHtml = $('.afterpay-enabled-content').html();
    var afterpayDisabledHtml = $('.afterpay-disabled-content').html();
    var showAfterpayErrorMessage = $('.js-grand-total').data('isafterpaydisable') ? afterpayDisabledHtml : '';
    var isAfterpayEnable = $('.js-grand-total').data('isafterpaydisable') || $('.js-grand-total').data('haspreorderitems') ? 'disabled' : '';
      if (paymentMethod.type === 'applepay') {
        liContents = '\n    <label class="payment-method-label" id="lb_'.concat(paymentMethodID, '" for="rb_').concat(paymentMethodID, '">').concat('\n <input name="brandCode" type="radio" alt="'+ label +'" value="').concat(paymentMethodID, '" id="rb_').concat(paymentMethodID, '">\n  <svg class="paymentMethod_img_' + paymentMethodID + '"><use xlink:href="#apple-pay"></use></svg>\n' ).concat('</label>\n ');
    } else if (paymentMethod.type === 'scheme' && !isStored) {
        liContents = '\n <label class="payment-method-label credit-card-label" id="lb_'.concat(paymentMethodID, '" for="rb_').concat(paymentMethodID, '">').concat('<input name="brandCode" type="radio" alt="'+ label +'" value="').concat(paymentMethodID, '" id="rb_').concat(paymentMethodID, '">\n').concat("<span class='payment-method-hassaved-card'><svg class='newcreditcard'><use xlink:href='#new-credit-card'></use></svg>New Credit Card </span><span class='payment-method-credit-card'>Credit Card </span><br /><span class='payment-method-different-cards d-none'>" + label, '</span></label>\n  ');
    } else if (paymentMethod.type === 'paypal') {
        liContents = '\n <label class="payment-method-label" id="lb_'.concat(paymentMethodID, '" for="rb_').concat(paymentMethodID, '">').concat('<input name="brandCode" type="radio" value="').concat(paymentMethodID, '" id="rb_').concat(paymentMethodID, '">\n <svg class="paymentMethod_img_' + paymentMethodID + '"><use xlink:href="#paypal-ds"></use></svg>\n <label class="d-none" id="lb_').concat(paymentMethodID, '" for="rb_').concat(paymentMethodID, '">').concat(label, '</label>\n<div class="body-font md klarna-available-msg d-none">' + label + '</div></label>');
    } else if (paymentMethod.type === 'klarna_account') {
        if (showKlarnaErrorMessage) {
            liContents = '\n <label class="payment-method-label" id="lb_'.concat(paymentMethodID, '" for="rb_').concat(paymentMethodID, '">').concat('<input name="brandCode" ' + isKlarnaEnable + ' type="radio" alt='+ label +' value="').concat(paymentMethodID, '" id="rb_').concat(paymentMethodID, '">\n <svg class="paymentMethod_img_' + paymentMethodID + '"><use xlink:href="#klarna"></use></svg>\n').concat('</label>\n <div class="body-font md klarna-error-msg">' + showKlarnaErrorMessage + '</div>');
        } else {
            liContents = '\n <label class="payment-method-label klarna-method"'.concat('" for="rb_').concat(paymentMethodID, '">').concat('<input name="brandCode" ' + isKlarnaEnable + ' type="radio" alt="'+ label +'" value="').concat(paymentMethodID, '" id="rb_').concat(paymentMethodID, '">\n <svg class="paymentMethod_img_' + paymentMethodID + '"><use xlink:href="#klarna"></use></svg>\n').concat('<label class="d-none" id="lb_'+ paymentMethodID +'">'+ label +'</label>').concat('\n <div class="body-font md klarna-available-msg">' + klarnaAvailableMsg + '<button type="button" class="btn-block ds-btn-block md klarna-submit-button">Pay with <svg><use xlink:href="#klarna-white-logo" /></svg></button> </div></label>');
        }
    } else if (paymentMethod.type === 'scheme' && isStored) {
        liContents = '\n <label class="payment-method-label payment-method-style" id="lb_'.concat(paymentMethodID, '" for="rb_').concat(paymentMethodID, '">').concat('<input name="brandCode" type="radio" value="').concat(paymentMethodID, '" id="rb_').concat(paymentMethodID, '">\n').concat('<span class="stored-card-label-text">'+ 'Saved Credit Card' +'</span>').concat('<span class="stored-card-label">'+ label +'</span><span class="stored-card-infotext">For your security, please re-enter your card’s security code.</span>', '</label>\n  ');
        $(document).find('.payment-methods-container').addClass('hassavedCard');
    } else if (paymentMethod.type === 'afterpaytouch' || paymentMethod.type === 'afterpaytouch_US' ) {
        if (showAfterpayErrorMessage) {
            liContents = '\n   <label class="payment-method-label"'.concat('" for="rb_').concat(paymentMethodID, '">').concat('<input name="brandCode" ' + isAfterpayEnable + ' type="radio" value="').concat(paymentMethodID, '" id="rb_').concat(paymentMethodID, '">\n <svg class="paymentMethod_img_' + paymentMethodID + '"><use xlink:href="#afterpay_updated"></use></svg>\n').concat('</label>\n <div class="body-font md afterpay-error-msg">' + showAfterpayErrorMessage + '</div>');
        } else {
            liContents = '\n <label class="payment-method-label"'.concat('" for="rb_').concat(paymentMethodID, '">').concat('<input name="brandCode" ' + isAfterpayEnable + ' type="radio" value="').concat(paymentMethodID, '" id="rb_').concat(paymentMethodID, '">\n <svg class="paymentMethod_img_' + paymentMethodID + '"><use xlink:href="#afterpay_updated"></use></svg>\n').concat('<label class="d-none" id="lb_').concat(paymentMethodID, '" for="rb_').concat(paymentMethodID, '">').concat(label, '</label>\n <div class="body-font md afterpay-available-msg">' + afterpayEnabledHtml + '<button type="button" class="btn-block ds-btn-block md afterpay-submit-button"><svg><use xlink:href="#afterpay-logo-white" /></svg></button></div></label>');
        }
    } else {
        liContents = '\n <label class="payment-method-label"><input name="brandCode" type="radio" value="'.concat(paymentMethodID, '" id="rb_').concat(paymentMethodID, '">\n    <label class="giftCardLabel" id="lb_').concat(paymentMethodID, '" for="rb_').concat(paymentMethodID, '">').concat(label, '</label></label>\n  ');
    }

    return liContents;
}

function klarnaButtonSubmit() {
    $(document).on('click', '.klarna-submit-button', function () {
        var selectedPaymentOption = $('.selected-payment-method').attr('data-method-id');
        $('#selectedPaymentOption').val(selectedPaymentOption);
        var checkoutHelpers = require('adyen/adyen/checkout');
        checkoutHelpers.setAdyenInputValues();
        // disable the submit payment button here
        $('body').trigger('checkout:disableButton', '.klarna-submit-button');
        $('#billingSameAsShippingID')[0].checked = true;
        $('#billingSameAsShippingID').trigger('change');
        if (document.querySelector('#selectedPaymentOption').value === 'AdyenComponent') {
            assignPaymentMethodValue();
            // validateComponents();
            showValidation();
        }

        var form = $('#dwfrm_billing');
        var defer = $.Deferred();
        var paymentMethod = 'klarna express';
        _require1.paymentMethodAnalytics(paymentMethod);
        $.spinner().start();
        $.ajax({
            type: 'POST',
            url: form.attr('action'),
            data: form.serialize(),
            async: false,
            success: function success(data) {
                if (data.error) {
                    $.spinner().stop();
                    store.formErrorsExist = 'fieldErrors' in data;
                    // enable the submit payment button here
                    $('body').trigger('checkout:enableButton', '.klarna-submit-button');

                    if (data.serverErrors.length) {
                        data.serverErrors.forEach(function (error) {
                            $('.error-message').show();
                            $('.error-message-text').text(error);
                            scrollAnimate($('.error-message'));
                        });
                    }

                    if (data.cartError) {
                        window.location.href = data.redirectUrl;
                    }

                    defer.reject();

                } else {
                    // GCT-15300 | Paypal Express changes | GCT-17209 Edit payment/ship/cart scenerio with paypal express order
                    updatePlaceOrderButton();
                    $.ajax({
                        url: $('.place-order').data('action'),
                        method: 'POST',
                        success: function (data) {
                            if (data.error) {
                                if (data.cartError) {
                                    window.location.href = data.redirectUrl;
                                    defer.reject();
                                } else {
                                    // go to appropriate stage and display error message
                                    defer.reject(data);
                                }
                                // ### Custom Adyen cartridge start ###
                            } else if (data.adyenAction) {
                                window.orderToken = data.orderToken;
                                actionHandler(data.adyenAction);
                                // ### Custom Adyen cartridge end ###
                            } else {
                                var redirect = $('<form>').appendTo(document.body).attr({
                                    method: 'POST',
                                    action: data.continueUrl
                                });
                                $('<input>').appendTo(redirect).attr({
                                    name: 'orderID',
                                    value: data.orderID
                                });
                                $('<input>').appendTo(redirect).attr({
                                    name: 'orderToken',
                                    value: data.orderToken
                                });
                                redirect.submit();
                                defer.resolve(data);
                            }
                        },
                        error: function () {
                            $.spinner().stop();
                            console.log('Klarna place order error, ajax failed');
                        }
                    });
                }
            },
            error: function (err) {
                 if (err.responseJSON?.action === "Ajax-Response" && err.responseJSON?.success === false){
                    let akamaiCheckoutErrorMessage = $('.checkoutPage-error-akamai').data('checkout-akamai-error');
                    $('.checkout-error-akamai-alert').empty().append(`<div class="checkout-error-akamai-message"><span class="icon-alert"></span><span class="err-message">${akamaiCheckoutErrorMessage} ${err.responseJSON["ckdr:"] ? err.responseJSON["ckdr:"] : err.responseJSON["thdr:"]}</span></div>`);
                }
                $.spinner().stop();
            }
        });
    });
}


function afterPaySubmitButton() {
    $(document).on('click', '.afterpay-submit-button', function () {
        var selectedPaymentOption = $('.selected-payment-method').attr('data-method-id');
        $('#selectedPaymentOption').val(selectedPaymentOption);
        var checkoutHelpers = require('adyen/adyen/checkout');
        checkoutHelpers.setAdyenInputValues();
        // disable the submit payment button here
        $('body').trigger('checkout:disableButton', '.afterpay-submit-button');
        var paymentMethod = 'afterpay';
        _require1.paymentMethodAnalytics(paymentMethod);

        if (document.querySelector('#selectedPaymentOption').value === 'AdyenComponent') {
            assignPaymentMethodValue();
               // validateComponents();
            showValidation();
        }

        var form = $('#dwfrm_billing');
        var defer = $.Deferred();
        $.spinner().start();
        $.ajax({
            type: 'POST',
            url: form.attr('action'),
            data: form.serialize(),
            async: false,
            success: function success(data) {
                if (data.error) {
                    $.spinner().stop();
                    store.formErrorsExist = 'fieldErrors' in data;
                    // enable the submit payment button here
                    $('body').trigger('checkout:enableButton', '.afterpay-submit-button');

                    if (data.serverErrors.length) {
                        data.serverErrors.forEach(function (error) {
                            $('.error-message').show();
                            $('.error-message-text').text(error);
                            scrollAnimate($('.error-message'));
                        });
                    }

                    if (data.cartError) {
                        window.location.href = data.redirectUrl;
                    }

                    defer.reject();

                } else {
                    // GCT-15300 | Paypal Express changes | GCT-17209 Edit payment/ship/cart scenerio with paypal express order
                    updatePlaceOrderButton();
                    $.ajax({
                        url: $('.place-order').data('action'),
                        method: 'POST',
                        success: function (data) {
                            if (data.error) {
                                $('.error-retrailCounter-message').empty().html();
                                $('.shipping-custom-message').empty().html();
                                $.spinner().stop();
                                if (data.cartError) {
                                    window.location.href = data.redirectUrl;
                                    defer.reject();
                                } else {
                                    // go to appropriate stage and display error message
                                    $('.error-message').show();
                                    if (data.errorStage && data.errorStage.stage === 'payment' && data.errorMessage) {
                                        $('.error-message-text').addClass('payment-error').html('<span class="alert-icon"><svg class="icon-error"><use xlink:href="#alert-red"></use></svg></span><span>' + data.errorMessage + '</span>');
                                        $('.global-alert').removeClass('d-none');
                                        var adyenCheckout = require('../checkout');
                                        adyenCheckout.init();
                                        scrollAnimate($('.error-message'));
                                        $('.loyalty-summary').removeClass('d-none');
                                    } else {
                                        $('.error-message-text').text(data.errorMessage);
                                    }
                                    defer.reject(data);
                                }
                                // ### Custom Adyen cartridge start ###
                            } else if (data.adyenAction) {
                                window.orderToken = data.orderToken;
                                actionHandler(data.adyenAction);
                                // ### Custom Adyen cartridge end ###
                            } else {
                                var redirect = $('<form>').appendTo(document.body).attr({
                                    method: 'POST',
                                    action: data.continueUrl
                                });
                                $('<input>').appendTo(redirect).attr({
                                    name: 'orderID',
                                    value: data.orderID
                                });
                                $('<input>').appendTo(redirect).attr({
                                    name: 'orderToken',
                                    value: data.orderToken
                                });
                                redirect.submit();
                                defer.resolve(data);
                            }
                        },
                        error: function () {
                            $.spinner().stop();
                            console.log('AfterPay place order error, ajax failed');
                        }
                    });
                }
            },
            error: function (err) {
                if (err.responseJSON?.action === "Ajax-Response" && err.responseJSON?.success === false){
                    let akamaiCheckoutErrorMessage = $('.checkoutPage-error-akamai').data('checkout-akamai-error');
                    $('.checkout-error-akamai-alert').empty().append(`<div class="checkout-error-akamai-message"><span class="icon-alert"></span><span class="err-message">${akamaiCheckoutErrorMessage} ${err.responseJSON["ckdr:"] ? err.responseJSON["ckdr:"] : err.responseJSON["thdr:"]}</span></div>`);
                } else if (err.responseJSON && err.responseJSON.responseToDisplay && typeof err.responseJSON.responseToDisplay.errorMessage === 'object' && 'msg' in err.responseJSON.responseToDisplay.errorMessage) {
                    const { msg } = err.responseJSON.responseToDisplay.errorMessage;
                    $('.error-retrailCounter-message').empty().html();
                    $('.shipping-custom-message').empty().html(`<p class="error-label">${msg}</p>`);
                    tealiumEnable.getAnalyticsData('serverError', err.responseJSON.responseToDisplay.errorMessage.errorCode);
                    scrollAnimate($('body'), 0);
                }
                $.spinner().stop();
            }
        });
    });
}

function applePaySubmitButton() {
    $(document).on('click', '.analytic-applepay-button', function () {
        var paymentMethod = 'applepay';
        _require1.paymentMethodAnalytics(paymentMethod);
    });
}

function paypalErrorHandler() {
    const checkPaypalStatus = () => {
        const paypalElm = document.getElementById('lb_paypal');
        if (!paypalElm) return;

        const parent = paypalElm.parentElement;
        const paypalInput = paypalElm.querySelector('input');

        let grandTotal = $('.d-summary-xs .grand-total-sum.estimated_total').text();
        let parsedTotal = parseFloat(grandTotal.split('$').join(''));
        let paymentUnavailable = $('#paymentMethodUnavailableMsg').val();
        let hasAppliedCards = $('.applied-card').length > 0;

        const shouldDisable = (parsedTotal <= 0 && hasAppliedCards);

        if (shouldDisable) {
            if (paypalInput) {
                paypalInput.setAttribute('disabled', 'disabled');
            }

            if (parent && !parent.querySelector('.payment-unavailable-msg')) {
                parent.insertAdjacentHTML('beforeend', `<div class="payment-unavailable-msg"></div>`);
                parent.querySelector('.payment-unavailable-msg').textContent = paymentUnavailable;
            }
        } else {
            if (paypalInput) {
                paypalInput.removeAttribute('disabled');
            }

            if (parent) {
                const errorMsg = parent.querySelector('.payment-unavailable-msg');
                if (errorMsg) errorMsg.remove();
            }
        }
    };

    const observer = new MutationObserver(() => {
        checkPaypalStatus();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
    });

    checkPaypalStatus();
}

module.exports = {
    renderGiftCard: renderGiftCard,
    updateAddressDetails: updateAddressDetails,
    handleAddressUpdateOnInputChange: handleAddressUpdateOnInputChange,
    creditDesText: creditDesText,
    credictCardList: credictCardList,
    applePayContent: applePayContent,
    klarnaDesText: klarnaDesText,
    paypalDesText: paypalDesText,
    generateLiContent: generateLiContent,
    klarnaButtonSubmit: klarnaButtonSubmit,
    afterPaySubmitButton: afterPaySubmitButton,
    applePaySubmitButton: applePaySubmitButton,
    paypalErrorHandler: paypalErrorHandler,
    giftCardFieldError: giftCardFieldError,
    showGiftCardAppleInfo: showGiftCardAppleInfo,
    giftCardCheckBalance: giftCardCheckBalance,
    trackServersideError: trackServersideError
}